import Big from "big.js";

export function numberFormat(value: string, digit = 8, separator = true) {
  if (typeof value !== "string") {
    return value;
  }
  const [int, decimal] = value.split(".");
  if (digit > 0) {
    if (separator) {
      const newInt = int.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      return `${newInt}${decimal ? "." + decimal.slice(0, digit) : ""}`;
    } else {
      return `${int}${decimal ? "." + decimal.slice(0, digit) : ""}`;
    }
  } else {
    return `${int}`;
  }
}

export function toNonExponential(num: number): string {
  const m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
  return num.toFixed(Math.max(0, (m?.[1] || "").length - Number(m?.[2] || 0)));
}

export function getPrecision(precision: string) {
  const number = toNonExponential(Number(precision));
  if (number) {
    if (number.includes(".")) {
      // 小数
      return number.slice(2).length;
    } else if (number === "1") {
      return 0;
    } else {
      return -(precision.length - 1);
    }
  } else {
    return 0;
  }
}

// transform USDT to $ or other
export const transformUSDT = (
  price: string,
  USDTRate = 1,
  rates = 1,
  symbolPrecision: string,
  symbol: string
) => {
  if (rates !== null && typeof window !== "undefined") {
    const p = new Big(price).times(USDTRate).times(rates).toFixed(2).toString();

    return ` ${symbol}${numberFormat(p, getPrecision(symbolPrecision))}`;
  } else {
    return "-";
  }
};
